import { send_request } from '../utils/Request';

/**
 *
 * @returns All workflows of the current user
 */
export const getWorkflows = async () =>
  send_request('project-service/project/getProjects', '', {}, 'get');

/**
 * @param projectId Id of the project
 * @returns All placeholder of the given $projectId
 */
export const getPlaceHolders = async projectId =>
  send_request(`component-service/placeholder/${projectId}`, '', {}, 'get');

/**
 * @returns A map with all placeholders grouped by component id (componentId as key)
 */
export const fetchPlaceholderKeysAsMap = async projectId =>
  send_request(`component-service/placeholder/placeholder_as_map/${projectId}`, '', {}, 'get');

/**
 * Canonical v2 placeholder map endpoint.
 * Returns placeholder-map.v2 payload.
 */
export const fetchPlaceholderKeysAsMapV2 = async (projectId, workflowVersion = null) =>
  send_request(
    `component-service/v2/placeholder/placeholder_as_map/${projectId}`,
    '',
    workflowVersion != null ? { workflowVersion } : null,
    'get'
  );
